import { WidgetViewModel } from './WidgetViewModel';
import { EditorDOMUtils } from 'Editor/services/_Common/DOM';
import { LockTooltipWidgetView } from '../../Views';

export class LockTooltipWidgetModel extends WidgetViewModel<'lockTooltip'> {
  constructor(
    Visualizer: Editor.Visualizer.State,
    refView: Editor.Visualizer.WidgetDataMapper['lockTooltip']['view'],
    props: Editor.Visualizer.WidgetDataMapper['lockTooltip']['props'],
  ) {
    super(Visualizer, refView, props);

    this.container.style.pointerEvents = 'none';
    this.container.dataset.type = 'lockTooltip';
  }

  render() {
    const offsets = EditorDOMUtils.getOffsets(this.refView);
    this.container.style.position = 'absolute';

    if (!offsets) {
      return;
    }
    let widgetPosition = 0;

    const isPageLayout = this.Visualizer.getLayoutType?.() === 'PAGE';

    if (isPageLayout) {
      this.container.style.left = 'calc(50%)';
      const widgetContainer = this.Visualizer.getWidgetsManager?.();
      if (!widgetContainer) {
        return;
      } else {
        widgetPosition = widgetContainer.widgetsDOMContainer.getBoundingClientRect().left;
      }
    }
    this.renderReactComponent(
      <LockTooltipWidgetView
        {...this.props}
        offsets={offsets}
        isPageLayout={isPageLayout}
        widgetContainerLeftOffset={widgetPosition}
      />,
    );
  }
}
